import Head from "next/head";
import { useEffect } from "react";
import ReactGA from "react-ga4";

ReactGA.initialize("G-2FWDPQXDLF");

export function HeaderMeta({includeSchemas, title="Chatmate AI - Artificial people to be friends with"}) { // 
      useEffect(() => {
        
      }, []);

      const softwareApplicationSchema = {
              "@context": "https://schema.org",
              "@type": "SoftwareApplication",
              "name": "Chatmate AI",
              "operatingSystem": "iOS, Android (via WhatsApp/Telegram/Messenger integration)",
              "applicationCategory": "SocialNetworkingApplication",
              "inLanguage": "All Languages",
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "5", // (Use a real average rating if available, otherwise consider omitting or starting high if confident)
                "reviewCount": "70" // (Use your actual number of reviews)
              },
              "offers": {
                "@type": "Offer",
                "price": "9.90",
                "priceCurrency": "USD",
                "priceSpecification": {
                  "price": "9.90",
                  "priceCurrency": "USD",
                  "@type": "PriceSpecification",
                  "valueAddedTaxIncluded": "false"
                },
                "category": "subscription"
              },
              "url": "https://chatmate.ai",
              "screenshot": "https://chatmate.ai/screenshot.jpg", // (e.g., https://chatmate.ai/images/screenshot1.png)
              "description": "Artificial intelligent people with simulated lives and emotions you can chat with and become friends."
            };
      const faqPageSchema =  {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What are Chatmates?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Chatmates are artificial intelligent persons with simulated lives and emotions you can chat with and become friends. They are powered by various AI models."
                }
              },
              {
                "@type": "Question",
                "name": "How much does Chatmate AI cost?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "All users can chat up to 50 messages and generate 3 photos per week FOR FREE. New users get an additional starter bonus. For more intense usage, a VIP subscription is available for $9.90/month."
                }
              },
              {
                "@type": "Question",
                "name": "What messengers can I use to chat with Chatmates?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "You can chat with Chatmates directly through your favorite messenger apps, including WhatsApp, Telegram, Instagram, and Messenger."
                }
              }
              // Add more Question/Answer blocks here as needed
            ]
          }

    return <Head>
            <title>{title}</title>
            <link rel="preconnect" href="https://fonts.googleapis.com"/>
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
            <link rel="dns-prefetch" href="https://fonts.googleapis.com"/>
            <link rel="dns-prefetch" href="https://fonts.gstatic.com"/>
            <link rel="shortcut icon" href="/favicon.ico" />
            <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
            <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
            <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;600&display=swap" rel="stylesheet"/>
            <meta charSet="utf-8" />
            <meta name="viewport" content="initial-scale=1.0, width=device-width" />
            <meta
                name="description"
                content="Revolutionize relationships with machines instead of just humans. Chatmates are artifical intelligent persons with simulated lifes and emotions you can chat with and become friends."
            />

            {false && includeSchemas ? <>
             <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareApplicationSchema) }}
                key="software-application-schema" // Add a key for best practice
              />
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }}
                key="faq-page-schema" // Add a key for best practice
              />
            </> : undefined} 
        </Head>
}
